import {actions} from '../actions';

const initialState = {
  stepIds: [],
  breadcrumbs: [],
  currentStepIndex: 0,
  currentStepId: null,
  fetchingTaxonomy: false,
  fetchingStep: false,
  fetchingReviews: false,
  completedSteps: false,
  completedServiceSelection: false,
  submitted: false,
  brief: null,
  error: null,
  page: 1,
  totalPages: 1,
};

export default function progressReducer(state = initialState, action) {
  switch (action.type) {
    case actions.PROGRESS.ERROR: {
      const {error} = action.payload;

      return {
        ...state,
        error,
      };
    }

    case actions.PROGRESS.COMPLETED_STEPS: {
      return {
        ...state,
        fetchingStep: false,
        completedSteps: true,
        error: null,
      };
    }

    case actions.PROGRESS.COMPLETE_SERVICE_SELECTION: {
      return {
        ...state,
        fetchingStep: false,
        completedServiceSelection: true,
        error: null,
      };
    }

    case actions.PROGRESS.RESET_SERVICE_SELECTION: {
      return {
        ...state,
        fetchingStep: false,
        completedServiceSelection: false,
        currentStepId: null,
        stepIds: [],
        error: null,
      };
    }

    case actions.PROGRESS.SUBMIT_PENDING: {
      return {
        ...state,
        fetchingStep: true,
        error: null,
      };
    }

    case actions.PROGRESS.SUBMIT_REJECTED: {
      const {error} = action.payload;

      return {
        ...state,
        fetchingStep: false,
        error,
      };
    }

    case actions.PROGRESS.SUBMIT_FULFILLED: {
      const {brief} = action.payload;

      return {
        ...state,
        fetchingStep: false,
        submitted: true,
        brief,
        error: null,
      };
    }

    case actions.TAXONOMY.FETCH_PENDING: {
      return {
        ...state,
        fetchingTaxonomy: true,
        error: null,
      };
    }

    case actions.TAXONOMY.FETCH_REJECTED: {
      const {error} = action.payload;

      return {
        ...state,
        fetchingTaxonomy: false,
        error,
      };
    }

    case actions.TAXONOMY.FETCH_FULFILLED: {
      return {
        ...state,
        fetchingTaxonomy: false,
        error: null,
      };
    }

    case actions.STEPS.FETCH_PENDING: {
      return {
        ...state,
        fetchingStep: true,
        completedSteps: false,
        error: null,
      };
    }

    case actions.STEPS.FETCH_FULFILLED: {
      const {step} = action.payload;
      const {stepIds, breadcrumbs} = state;
      const newStepIds = stepIds.includes(step.handle)
        ? state.stepIds
        : [...state.stepIds, step.handle];
      const newBreadcrumbs = step.breadcrumbs
        ? [...step.breadcrumbs]
        : breadcrumbs;

      return {
        ...state,
        stepIds: newStepIds,
        breadcrumbs: newBreadcrumbs,
        fetchingStep: false,
        currentStepId: newStepIds[state.currentStepIndex],
        error: null,
      };
    }

    case actions.STEPS.DYNAMIC_SELECTION: {
      const {stepHandle} = action.payload;
      const {stepIds} = state;

      return {
        ...state,
        stepIds: stepIds.slice(0, stepIds.indexOf(stepHandle) + 1),
      };
    }

    case actions.STEPS.FETCH_REJECTED: {
      const {error} = action.payload;

      return {
        ...state,
        fetchingStep: false,
        error,
      };
    }

    case actions.STEPS.CHANGE: {
      const {index} = action.payload;

      return {
        ...state,
        currentStepIndex: index,
        currentStepId: state.stepIds[index],
        completedSteps: false,
        error: null,
      };
    }

    case actions.STEPS.PREVIOUS: {
      const previousStepIndex = state.currentStepIndex - 1;

      return {
        ...state,
        currentStepIndex: previousStepIndex,
        currentStepId: state.stepIds[previousStepIndex],
        completedSteps: false,
        error: null,
      };
    }

    case actions.STEPS.NEXT: {
      const nextStepIndex = state.currentStepIndex + 1;

      return {
        ...state,
        currentStepIndex: nextStepIndex,
        currentStepId: state.stepIds[nextStepIndex],
        completedSteps: false,
        error: null,
      };
    }

    case actions.QUESTIONS.FETCH_REJECTED: {
      const {error} = action.payload;

      return {
        ...state,
        error,
      };
    }

    case actions.QUESTIONS.FETCH_FULFILLED: {
      return {
        ...state,
        error: null,
      };
    }
  }

  return state;
}
